import { IoMailOutline, IoMapOutline, IoCallOutline } from "react-icons/io5";
import { useEffect } from "react";

export default function Footer() {
  // Scroll suave hacia un id específico
  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        window.history.pushState(null, "", `#${targetId}`);
      }, 0);
    }
  };

  // Si entra con un hash directo en la URL
  useEffect(() => {
    const hash = window.location.hash.substr(1);
    if (hash) {
      setTimeout(() => handleSmoothScroll(new Event("click"), hash), 100);
    }
  }, []);

  return (
    <section className="bg-white text-neutral-600 py-10">
      <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Logo e Introducción */}
        <div className="mb-6 md:mb-0">
          <div className="flex justify-start mb-4 gap-6">
            <img src="/img/logo/logo.png" className="h-24 w-auto max-w-xs" alt="Logo" />
            <div className="flex justify-center items-center">
              <span className="text-neutral-700 text-4xl font-bold">Border Protect</span>
            </div>
          </div>
          <p className="text-neutral-600">
            Border Protect Seguridad Privada ofrece soluciones integrales en seguridad y vigilancia
            profesional para empresas, residencias y eventos en Sonora.
          </p>
        </div>

        {/* Contacto */}
        <div className="mb-6 md:mb-0">
          <h4 className="text-lg font-bold mb-3">Contacto</h4>

          <div className="flex items-center mb-2">
            <IoMailOutline className="text-xl text-[#23346E]" />
            <a
              href="mailto:contacto@seguridadbp.com"
              className="ml-2 text-neutral-600 hover:text-blue-700 transition"
            >
              contacto@seguridadbp.com
            </a>
          </div>
          <div className="flex items-center mb-2">
            <IoCallOutline className="text-xl text-[#23346E]" />
            <a
              href="tel:6311934479"
              className="ml-2 text-neutral-600 hover:text-red-700 transition font-semibold"
            >
              631-193-4479
            </a>
          </div>

          <div className="flex items-center mb-2">
            <IoCallOutline className="text-xl text-[#23346E]" />
            <a
              href="tel:6312091989"
              className="ml-2 text-neutral-600 hover:text-red-700 transition font-semibold"
            >
              631-209-1989
            </a>
          </div>

          <div className="flex items-start">
            <IoMapOutline className="text-xl text-[#23346E] mt-1" />
            <a
              href="https://www.google.com/maps?q=Ave.+Álvaro+Obregón+1033,+Local+105,+Colonia+Moderna,+C.P.+84055,+Nogales,+Sonora"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-2 text-neutral-600 hover:text-green-700 transition"
            >
              Ave. Álvaro Obregón #1033, Local 105, Colonia Moderna, C.P. 84055, H. Nogales, Sonora.
            </a>
          </div>
        </div>

        {/* Secciones con scroll suave */}
        <div>
          <h4 className="text-lg font-bold mb-3">Secciones</h4>
          <ul className="space-y-2">
            <li>
              <a
                href="#home"
                onClick={(e) => handleSmoothScroll(e, "home")}
                className="text-neutral-600 hover:text-neutral-800 transition"
              >
                Inicio
              </a>
            </li>
            <li>
              <a
                href="#about"
                onClick={(e) => handleSmoothScroll(e, "nosotros")}
                className="text-neutral-600 hover:text-neutral-800 transition"
              >
                Nosotros
              </a>
            </li>
            <li>
              <a
                href="#services"
                onClick={(e) => handleSmoothScroll(e, "servicios")}
                className="text-neutral-600 hover:text-neutral-800 transition"
              >
                Servicios
              </a>
            </li>
            
            <li>
              <a
                href="#contactus"
                onClick={(e) => handleSmoothScroll(e, "contacto")}
                className="text-neutral-600 hover:text-neutral-800 transition"
              >
                Contáctanos
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
